import "core-js/modules/es.object.assign.js";
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["data-active", "onClick"];
var _hoisted_2 = ["innerHTML"];
import BaseAccordion from "@vueEntry/UIKitComponents/Accordion/BaseAccordion.vue";
import BaseAccordionItem from "@vueEntry/UIKitComponents/Accordion/BaseAccordionItem.vue";
import CheckboxGroup from "@vueEntry/UIKitComponents/Checkbox/CheckboxGroup.vue";
import { useLTMS } from "@wkComposables/useLTMS";
import { useListingTypologyStore } from "@store/ListingTypologyStore";
import { stringToHyphened } from "@utils/StringUtils";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'TypologiesAccordion',
  props: {
    listingTypologies: {}
  },
  setup(__props) {
    var props = __props;
    var lts = useListingTypologyStore();
    var {
      curGroup,
      getKey
    } = useLTMS({
      onChangeEmit: true,
      listingTypologies: props.listingTypologies
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" MacroTypologies "), _createVNode(BaseAccordion, null, {
        default: _withCtx(_ref => {
          var {
            updatePrev
          } = _ref;
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lts).macroTypologiesObj, _macroTypologyObj => {
            return _openBlock(), _createBlock(BaseAccordionItem, {
              id: _macroTypologyObj.macroTypologyID,
              key: _macroTypologyObj.macroTypologyID,
              "data-cy": "accordion_".concat(_unref(stringToHyphened)(_macroTypologyObj.group)),
              "btn-classes": _ctx.$attrs['btn-classes'],
              title: _macroTypologyObj.group,
              active: _macroTypologyObj.active,
              onAccordionOpened: a => updatePrev(a, _unref(lts).macroTypologiesObj)
            }, {
              default: _withCtx(() => [_createVNode(CheckboxGroup, {
                modelValue: _unref(lts).typologiesSelected,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(lts).typologiesSelected = $event),
                "checkbox-padding-y": _ctx.$attrs['checkbox-py'],
                "values-obj": _unref(lts).typologiesObj[_macroTypologyObj.macroTypologyID],
                "form-check-inline": false,
                "group-id": _macroTypologyObj.group,
                "auto-check-reset-empty": true,
                reset: _unref(curGroup) !== _macroTypologyObj.group,
                "get-key": _unref(getKey),
                onCheckedGroup: _cache[1] || (_cache[1] = g => curGroup.value = g)
              }, null, 8 /* PROPS */, ["modelValue", "checkbox-padding-y", "values-obj", "group-id", "reset", "get-key"])]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "data-cy", "btn-classes", "title", "active", "onAccordionOpened"]);
          }), 128 /* KEYED_FRAGMENT */))];
        }),
        _: 1 /* STABLE */
      }), _createCommentVNode(" Single Typologies "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lts).singleTypologies, singleTypology => {
        return _openBlock(), _createElementBlock("button", {
          key: singleTypology.id,
          type: "button",
          "data-active": _unref(lts).typologiesSelected.some(t => singleTypology.listingTypologyId === t.listingTypologyId),
          class: _normalizeClass([_ctx.$attrs['st-classes'], "tw-pl-25px tw-py-15px tw-bg-transparent hover:tw-cursor-pointer hover:tw-bg-w-cultured tw-text-left tw-w-full [&[data-active='true']]:tw-font-semibold [&[data-active='true']]:tw-bg-w-cultured"]),
          onClick: _withModifiers($event => {
            _unref(lts).typologiesSelected = [singleTypology];
            curGroup.value = singleTypology.label;
          }, ["stop"])
        }, [_createElementVNode("span", {
          innerHTML: singleTypology.label
        }, null, 8 /* PROPS */, _hoisted_2)], 10 /* CLASS, PROPS */, _hoisted_1);
      }), 128 /* KEYED_FRAGMENT */))], 64 /* STABLE_FRAGMENT */);
    };
  }
}));